import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useBreakpoint } from '@ocean/hooks'
import { modals } from '@ocean/ui'
import { useLazySelector } from 'hooks'
import { PrivacyPolicy } from 'core/userDeclaration/components'
import { namespace } from 'core/userDeclaration/localization'
import {
  changePrivacyPolicyPopupVisibility,
  getPrivacyPolicy,
} from 'core/userDeclaration/slices/userDeclaration'

const { Popup } = modals

const I18_PATH = `${namespace}:userDeclaration`

const PrivacyPolicyContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isDesktop = useBreakpoint('sm')
  const { privacyPolicyPopupIsShown, endUserDeclarationText = '' } = useLazySelector(
    ({ userDeclaration }) => {
      return {
        privacyPolicyPopupIsShown: userDeclaration.privacyPolicyPopupIsShown,
        endUserDeclarationText:
          userDeclaration.userDeclarationData.result?.data.endUserDeclarationText,
      }
    }
  )
  const showPopup = privacyPolicyPopupIsShown && !!endUserDeclarationText

  useEffect(() => {
    if (privacyPolicyPopupIsShown && !endUserDeclarationText) {
      dispatch(getPrivacyPolicy())
    }
  }, [dispatch, privacyPolicyPopupIsShown, endUserDeclarationText])

  function handleClosePrivacyModal() {
    dispatch(changePrivacyPolicyPopupVisibility(false))
  }

  return (
    <Popup
      isOpen={showPopup}
      onClose={handleClosePrivacyModal}
      title={t(`${I18_PATH}.privacyPolicy`)}
      width={isDesktop ? '728px' : undefined}
      dataTest='ProfilePrivacyPolicyPopup'
    >
      <PrivacyPolicy
        endUserDeclarationText={endUserDeclarationText}
        onClose={handleClosePrivacyModal}
      />
    </Popup>
  )
}

export default PrivacyPolicyContainer
